import { useQuery } from "@tanstack/react-query";
import { getCurrentUser } from "../requests/auth";

export function useCurrentUser() {
  return useQuery({
    queryKey: ["user/me"],
    queryFn: async () => {
      const res = await getCurrentUser();
      // console.log("res", res);
      return res.data?.contact;
    },
  });
}
